module.exports = __webpack_public_path__ + "img/7B6E5B_C5CACC_B1B2AE_322415-256px.d2c5260b.png";